import api from './api';

export async function getMobileStands() {
  const { data } = await api.get('/mobile-stand');
  return data;
}

export async function createMobileStand(payload) {
  const { data } = await api.post('/mobile-stand', payload);
  return data;
}

export async function updateMobileStand(id, payload) {
  const { data } = await api.put(`/mobile-stand/${id}`, payload);
  return data;
}

export async function deleteMobileStand(id) {
  const { data } = await api.delete(`/mobile-stand/${id}`);
  return data;
}
